<template>
  <div class="news1">
    <p style="text-align: center;"><img src="https://p7.itc.cn/q_70/images03/20220506/f86abcbc1f064d00a91fbf41287bec3e.png"></p>
    <p style="text-align: center;"><strong><span style="font-size: 16px;">4项化纤行业推荐性国标一览表</span></strong></p>
    <p style="text-align: center;"><img src="https://p0.itc.cn/q_70/images03/20220506/5b5ffcad32834edc9b50b93026f9965c.png"></p>
    <p style="text-align: center;"><img src="https://p3.itc.cn/q_70/images03/20220506/f3df8ae3c4a4422ba6bbc86d1dca79a1.png"></p>
    <p><span style="font-size: 16px;">近日，工业和信息化部发布2022年10号公告，批准《化工装置管道机械设计规定》等555项行业标准。其中，纺织行业103项标准正式发布，包括化纤行业17项行业标准，该17项行业标准实施日期为2022年10月1日</span><span style="font-size: 16px;">，归口在全国化学纤维标准化技术委员会（SAC/TC586）。</span></p>
    <p style="text-align: center;"><span style="font-size: 16px;"><strong><span>17项化纤行业标准一览表</span></strong></span></p>
    <p style="text-align: center;"><img src="https://p0.itc.cn/q_70/images03/20220506/db29255e83244c748e021ae5ae5f7eb0.jpeg"></p>
    <p style="text-align: center;"><img src="https://p8.itc.cn/q_70/images03/20220506/d2515ace26174223a125836d3b6c198e.jpeg"></p>
    <p style="text-align: center;"><img src="https://p3.itc.cn/q_70/images03/20220506/8e272585b8024143a96a41027fc2753d.jpeg"></p>
    <p style="color: #999; text-align: center">来源：中国纺织/工信部/国家市场监管总局/国家标准管委会</p>
  </div>

</template>
<script>
  export default {
    name: 'news9'
  }
</script>

<style scoped>
  .news1{
    text-align: left;
    font-size: 18px;
    line-height: 200%;
    background: #fff;
    color: #333;
    margin-top: -10px;
    padding: 20px 30px;
  }

  .news1 p{
    font-family: 微软雅黑;
    text-indent: 2em;
    line-height: 145%;
    margin: 6px 0;
  }

  .news1 p img{
    display: block;
    max-width: 100%;
    margin: 12px auto;
  }

</style>



// WEBPACK FOOTER //
// src/views/new/news9.vue